import { Flex, Typography } from '@aloft/toolkit-sui';

import { selectPropertyType } from '../../redux/features/selectors/orderSelectors.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { CommentarySection } from './components/CommentarySection.tsx';
import { getMethodologyText } from './consts.ts';
import { getCommentarySectionText } from './utils.ts';

export const Methodology = () => {
  const propertyType = useAppSelector(selectPropertyType);
  if (propertyType === undefined) {
    throw new Error('Property type is undefined');
  }

  const methodologyText = getMethodologyText(propertyType);

  return (
    <CommentarySection {...getCommentarySectionText('methodology')}>
      <Flex flexDirection="column" gap={2}>
        {methodologyText.map((text, index) => (
          <Typography key={index} variant="body1">
            {text}
          </Typography>
        ))}
      </Flex>
    </CommentarySection>
  );
};
